import type { ConversationListItemDto } from "@multi-chat/shared";

export const CONVERSATION_ROW_COUNT_CAP = 99;

/** Visible unread pill text, or null when the row has nothing unread. */
export function conversationRowUnreadLabel(unreadCount: number): string | null {
  if (!Number.isFinite(unreadCount) || unreadCount <= 0) return null;
  return unreadCount > CONVERSATION_ROW_COUNT_CAP
    ? `${CONVERSATION_ROW_COUNT_CAP}+`
    : String(Math.trunc(unreadCount));
}

export type ConversationRowContactMark = "unsaved" | "deleted";

type ContactState = ConversationListItemDto["contactPlatformProfile"]["contactState"];

/** Small state icon beside the row name; saved contacts carry no mark. */
export function conversationRowContactMark(
  contactState: ContactState,
): ConversationRowContactMark | null {
  switch (contactState) {
    case "NOT_SAVED":
      return "unsaved";
    case "DELETED":
      return "deleted";
    case "ACTIVE":
      return null;
    default: {
      const exhaustive: never = contactState;
      return exhaustive;
    }
  }
}
